module.exports = __webpack_public_path__ + "img/deliveryArrival.e9e372c5.png";